export default __webpack_public_path__ + "static/media/img-teams_3.5eb5a65d.svg";